/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerFindOwnersQueryResponse, OrganizationsControllerFindOwnersQueryParams } from "../../models/organizationsController/OrganizationsControllerFindOwners";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { organizationsControllerFindOwners } from "../../clients/organizationsService/organizationsControllerFindOwners";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const organizationsControllerFindOwnersQueryKey = (params: OrganizationsControllerFindOwnersQueryParams) => [{
  url: '/api/v1/organizations/owners'
}, ...(params ? [params] : [])] as const;
export type OrganizationsControllerFindOwnersQueryKey = ReturnType<typeof organizationsControllerFindOwnersQueryKey>;
export function organizationsControllerFindOwnersQueryOptions(params: OrganizationsControllerFindOwnersQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = organizationsControllerFindOwnersQueryKey(params);
  return queryOptions<OrganizationsControllerFindOwnersQueryResponse, ResponseErrorConfig<Error>, OrganizationsControllerFindOwnersQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return organizationsControllerFindOwners(params, config);
    }
  });
}

/**
 * @summary Get organization owners/admins for organizations
 * {@link /api/v1/organizations/owners}
 */
export function useOrganizationsControllerFindOwners<TData = OrganizationsControllerFindOwnersQueryResponse, TQueryData = OrganizationsControllerFindOwnersQueryResponse, TQueryKey extends QueryKey = OrganizationsControllerFindOwnersQueryKey>(params: OrganizationsControllerFindOwnersQueryParams, options: {
  query?: Partial<QueryObserverOptions<OrganizationsControllerFindOwnersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? organizationsControllerFindOwnersQueryKey(params);
  const query = useQuery({
    ...organizationsControllerFindOwnersQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}